import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { ActionHandlerFunction, CollectionServerUser } from "@preveil-api";
import { AdminUIActionTypes, CheckboxStates } from "src/common";
import { Checkbox, Icon } from "src/components";
import _ from "lodash";

type AllProps = {
  user: CollectionServerUser;
  selected: boolean;
  handleAction: ActionHandlerFunction;
}

// Description: List row component for the cloud lock settings page
function ListRowComponent(props: AllProps) {
  const { user, selected, handleAction } = props;

  function handleSelect() {
    handleAction({ actionType: AdminUIActionTypes.Select, params: { id: user.user_id, selected: !selected } });
  }

  return <Row onClick={handleSelect}>
    <Col md="1">
      <Checkbox
        className="sr-only"
        onChange={handleSelect}
        selected={selected ? CheckboxStates.checked : CheckboxStates.empty}
        value="all" label="Select All" />
    </Col>
    <Col md="4" className="col">{user.display_name}</Col>
    <Col md="3">{user.user_id.toLowerCase()}</Col>
    <Col md="3">{_.capitalize(user.entity_metadata.role)}</Col>
    <Col sm={1} className="text-end ms-auto">
      <Button
        variant="icon"
        size="sm"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => { e.stopPropagation(); handleAction({ actionType: AdminUIActionTypes.Delete, params: { users: [user.user_id] } }); }}
        title="Remove User from Sync Permissions"
        data-tooltip-id="pv-tooltip"
        data-tooltip-content="Remove User from Sync Permissions">
        <Icon className="ficon-x" />
      </Button>
    </Col>
  </Row>;
}

export default React.memo(ListRowComponent);